// extracted by mini-css-extract-plugin
export var container = "IconText-module--container--dNclG";
export var icon = "IconText-module--icon--wGxDD";
export var large = "IconText-module--large--2hxTJ";
export var textContainer = "IconText-module--textContainer--aSBQ2";
export var title = "IconText-module--title--30bEB";
export var text = "IconText-module--text--31uGD";
export var small = "IconText-module--small--2CvwV";
export var sm = "IconText-module--sm--1Z1pV";